import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ItemListComponent } from '../../atoms/atoms.index';
import {
  NavbarComponent,
  NavigationMenuComponent,
  NewWishListModalFormComponent,
} from '../../organisms/organisms.index';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import {
  deleteWishList,
  loadWishListCatalogue,
  newWishList,
  resetWishListCatalogue,
} from '../../../store/wishlist/wishlist.actions';
import { makeSelectWishListCatalogue } from '../../../store/wishlist/wishlist.selectors';
import { returnNotification } from '../../../store/render-controller/render-controller.actions';
import { ENotification } from '../../../domain/notification.interface';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ERoutes } from '../../../assets/constants/routes';
import { replacePathParams } from '../../../utils/NavigateWithParams';
import { destroy } from 'redux-form';
import { HttpService } from '../../../services/services.index';
import { EEndpoint } from '../../../config/endpoint.config';
import './WishListCatalogue.component.scss';
import { EFormName } from '../../../config/form-names.config';
import { EItemList } from '../../atoms/itemList/ItemList.component';

export function WishListCatalogueComponent(props: any) {
  const dispatch = useDispatch();
  const httpService = new HttpService();

  const wishListCatalogueReducer = useSelector(makeSelectWishListCatalogue());
  const [wishListCatalogue, setWishListCatalogue] = useState();

  const [readOnly, setReadOnly] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    setTimeout(() => {
      if (props.location.state && props.location.state.readOnly) {
        setReadOnly(true);
      } else {
        setReadOnly(false);
      }
      return () => {
        setReadOnly(undefined);
      };
    }, 10);
    // eslint-disable-next-line
  }, []);

  const fetchUserWishlistcatalogue = async (userId: string) => {
    const res = await httpService.get(EEndpoint.GET_USER_WISH_LIST_CATALOGUE, {
      params: { userId: userId },
    });
    setWishListCatalogue(res as any);
  };

  useEffect(() => {
    if (readOnly === undefined) {
      return;
    } else if (readOnly) {
      fetchUserWishlistcatalogue(props.location.state.contact.id);
    } else {
      dispatch(loadWishListCatalogue());
    }
    return () => {
      dispatch(resetWishListCatalogue());
    };
    // eslint-disable-next-line
  }, [readOnly]);

  useEffect(() => {
    setWishListCatalogue(wishListCatalogueReducer);
    return () => {
      setWishListCatalogue(undefined);
    };
  }, [wishListCatalogueReducer]);

  const [showModal, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  function submitForm(values: any) {
    handleClose();
    dispatch(newWishList(values));
    dispatch(destroy(EFormName.NEW_WISH_LIST));
  }

  const checkDelete = (isDefault: boolean) => {
    return !(isDefault || readOnly);
  };

  function deleteFunction(id: number) {
    dispatch(
      returnNotification({
        type: ENotification.WARNING,
        msg1: 'warning.confirmation.message',
        dispatch: { func: deleteWishList, param: [id] },
      }),
    );
  }

  const nameToShow = readOnly
    ? props.location.state.contact.alias
      ? props.location.state.contact.alias
      : props.location.state.contact.nickname
    : undefined;

  return (
    <div className='wishlist-container fluid-container page-container'>
      <NavbarComponent />
      <NavigationMenuComponent {...props} />
      <div className='content-wrapper'>
        <div className='title-container'>
          {readOnly ? (
            <div>
              <h4 className='subtitle'>
                <FormattedMessage id='pages.wishlist_catalogue.contact.title' />{' '}
                <span className='name-to-show'>{nameToShow}</span>
              </h4>
            </div>
          ) : (
            <button className='add-btn mb-2' onClick={handleShow}>
              <FontAwesomeIcon icon='plus-circle' />{' '}
              <FormattedMessage id='pages.wishlist_catalogue.add_wishlist' />
            </button>
          )}
        </div>
        <section className='itemlist-container'>
          <ul className='itemlist d-flex flex-wrap justify-content-between align-items-center'>
            {!!wishListCatalogue &&
              (wishListCatalogue as any).map((list: any) => {
                return (
                  <Link
                    to={
                      readOnly
                        ? {
                            pathname: replacePathParams(
                              ERoutes.CONTACT_WISH_LIST,
                              {
                                wishListId: list.id,
                              },
                            ),
                            state: { readOnly: true, name: nameToShow },
                          }
                        : {
                            pathname: replacePathParams(ERoutes.WISH_LIST, {
                              wishListId: list.id,
                            }),
                          }
                    }
                    key={list.id}
                  >
                    <ItemListComponent
                      name={list.name}
                      deleteFunction={
                        checkDelete(list.isDefault)
                          ? (e: any) => {
                              e.preventDefault();
                              deleteFunction(list.id);
                            }
                          : null
                      }
                      type={EItemList.WISHLIST}
                      isDefault={list.isDefault}
                      visibility={list.visibility}
                    />
                  </Link>
                );
              })}
          </ul>
        </section>
      </div>
      <NewWishListModalFormComponent
        {...props}
        showModal={showModal}
        handleClose={handleClose}
        submitForm={submitForm}
      />
    </div>
  );
}
